import { refreshAuth } from "./refresh";

const REFRESH_MARGIN_SECONDS = 60; // refresh 60s before expiry

let accessTokenObj = null;   
let refreshTimer = null;

export const setAccessToken = (tokenObj, baseURL = "") => {
  accessTokenObj = tokenObj || null;
  scheduleProactiveRefresh(baseURL);
};

export const getAccessToken = () => {
  return accessTokenObj;
};

export const getAccessTokenString = () => {
  const tokenString = accessTokenObj?.token || null;
  return tokenString;
};

export const clearAccessToken = () => {
  accessTokenObj = null;
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
};

// JWT parsing & scheduler
function parseJwtPayload(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const parsed = JSON.parse(jsonPayload);
    return parsed;
  } catch (e) {
    console.error("[auth] parseJwtPayload failed:", e);
    return null;
  }
}

function scheduleProactiveRefresh(baseURL) {
  // clear existing timer
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }

  const token = getAccessTokenString();
  if (!token) {
    console.warn("[auth] no token found, skipping scheduleProactiveRefresh");
    return;
  }

  const payload = parseJwtPayload(token);
  if (!payload || !payload.exp) {
    console.warn("[auth] no payload or exp in token, skipping scheduleProactiveRefresh");
    return;
  }
  const nowSec = Math.floor(Date.now() / 1000);
  const msUntilExp = (payload.exp - nowSec) * 1000;

  const msUntilRefresh = msUntilExp - REFRESH_MARGIN_SECONDS * 1000;

  if (msUntilRefresh <= 0) {
    refreshAuth(baseURL)
      .then((newTokenObj) => {
        setAccessToken(newTokenObj, baseURL);
      })
      .catch((err) => {
        console.error("[auth] proactive refresh failed (immediate):", err);
        clearAccessToken();
      });
    return;
  }

  refreshTimer = setTimeout(async () => {
    try {
      const newTokenObj = await refreshAuth(baseURL);
      setAccessToken(newTokenObj, baseURL);
    } catch (e) {
      console.error("[auth] proactive refresh error (scheduled):", e);
      clearAccessToken();
    }
  }, msUntilRefresh);
}
